import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4a92eb6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "smsOverlayBanner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "dashedBorder" }
const _hoisted_5 = { class: "smsRoutesWrapper" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = {
  key: 0,
  class: "routesTitleAndButtonWrapper"
}
const _hoisted_8 = { class: "routesTitle" }
const _hoisted_9 = { class: "routesTitleAndButtonWrapper" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "addRouteCardWrapper" }
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "addRouteButtonWrapper" }
const _hoisted_15 = { class: "addRouteButtonInner" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal",
  class: "deleteRouteSubscriptionModal"
}, null, -1))

import {
  computed, ref, watch,
} from 'vue';
import { storeToRefs } from 'pinia';
import { buildLoginRequest } from '@auth/requests';
import { useMsalRedirectGuard, useIsAuthenticated, useMsalToken } from '@auth/composables';
import { useRouteSubscriptionStore, useRoutesStore } from '@components/stores';
import { SignOutButton, Icon, TimezoneWarning } from '@components/Atoms';
import {
  NoRoutesCard, RouteSubscriptionCard, AddRouteSubscriptionCard, InfoCard,
} from '@components/Molecules';
import { useI18n } from 'vue-i18n';
import { setAcquireToken } from '@components/services/ApolloClient';

import { INFO_CARD_COLOR } from '@constants/info-card-color';
import { msalInstance } from '@/auth/authConfig';
import { b2cRedirectUri, b2cScopes } from '../envVariables';
import { skeletonSubscriptions } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmsApp',
  setup(__props) {

const { t } = useI18n();

// Use redrect guard to ensure that the user is logged in before continuing
const redirectRequest = buildLoginRequest(b2cRedirectUri, b2cScopes);
const routeSubscriptionsStore = useRouteSubscriptionStore();
const {
  getSubscriptions,
} = routeSubscriptionsStore;
const {
  subscriptions,
  availableRoutes,
  allRoutes,
  isSubscriptionLoading,
  isSubscriptionUpdating,
  isSubscriptionFetchError,
} = storeToRefs(routeSubscriptionsStore);

// Get authentication state for sign out button
const {
  isAuthenticated,
} = useIsAuthenticated(redirectRequest);
const { acquireToken } = useMsalToken(redirectRequest);

// Set the acquire token method for the apollo client - do not remove
setAcquireToken(acquireToken);

const routesStore = useRoutesStore();
const { requestAllRoutes } = routesStore;
requestAllRoutes();

const showAddRouteCard = ref(false);
const showTimezoneWarning = ref(true);

const apiError = computed(() => (isSubscriptionFetchError.value ? t('SMS Api error') : ''));

const stopWatch = watch(() => isAuthenticated.value, async (isAuth: boolean | undefined) => {
  if (isAuth) {
    getSubscriptions();
    setTimeout(() => stopWatch(), 0);
  }
}, { immediate: true });

const showNoRoutes = computed(() => isAuthenticated.value
  && !apiError.value
  && subscriptions.value
  && subscriptions?.value?.length === 0
  && !showAddRouteCard.value
  && !isSubscriptionLoading.value);

const showAddRouteButton = computed(() => isAuthenticated.value
  && subscriptions.value
  && subscriptions.value.length > 0
  && !isSubscriptionLoading.value);

const subscriptionsToShow = computed(() => {
  if (subscriptions.value && subscriptions.value.length > 0) {
    return subscriptions.value;
  }
  if (isSubscriptionLoading.value) {
    return skeletonSubscriptions;
  }
  return [];
});

const handleShowAddRoute = () => {
  showAddRouteCard.value = true;
};

const handleCloseAddRoute = () => {
  showAddRouteCard.value = false;
};

const handleSignOut = () => {
  msalInstance.logoutRedirect();
};

const handleWarningClose = () => {
  showTimezoneWarning.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showTimezoneWarning.value)
      ? (_openBlock(), _createBlock(_unref(TimezoneWarning), {
          key: 0,
          onClose: handleWarningClose
        }))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Manage my text alerts')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_unref(isAuthenticated))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('myRoutes')), 1),
              _createVNode(_unref(SignOutButton), { onClick: handleSignOut })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (apiError.value)
            ? (_openBlock(), _createBlock(_unref(InfoCard), {
                key: 0,
                class: "infoCard",
                "icon-name": "warning",
                text: apiError.value,
                lg: true,
                "background-color": _unref(INFO_CARD_COLOR).white,
                "border-color": _unref(INFO_CARD_COLOR).red
              }, null, 8, ["text", "background-color", "border-color"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (showNoRoutes.value)
        ? (_openBlock(), _createBlock(_unref(NoRoutesCard), {
            key: 0,
            routes: _unref(availableRoutes)
          }, null, 8, ["routes"]))
        : _createCommentVNode("", true),
      (subscriptionsToShow.value && subscriptionsToShow.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptionsToShow.value, (subscription) => {
              return (_openBlock(), _createBlock(_unref(RouteSubscriptionCard), {
                key: subscription.textCode,
                "text-code": subscription.textCode,
                "is-loading": _unref(isSubscriptionLoading),
                "is-updating": _unref(isSubscriptionUpdating),
                routes: _unref(allRoutes),
                "start-date": subscription.startDate,
                "end-date": subscription.endDate
              }, null, 8, ["text-code", "is-loading", "is-updating", "routes", "start-date", "end-date"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (showAddRouteCard.value)
            ? (_openBlock(), _createBlock(_unref(AddRouteSubscriptionCard), {
                key: 0,
                routes: _unref(availableRoutes),
                onSaved: handleCloseAddRoute,
                onCancel: handleCloseAddRoute
              }, null, 8, ["routes"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (showAddRouteButton.value && !showAddRouteCard.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "button",
                  onClick: handleShowAddRoute
                }, [
                  _createVNode(_unref(Icon), { "icon-name": "plus" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Add new route')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _hoisted_16
  ], 64))
}
}

})